/**
 * Skeuomorphic 3D tiles used on Main Page and My Courses — kept in sync for consistent chrome.
 */
export function getTile3dWebStyle(theme, pressed) {
  const t = pressed ? 4 : 0;
  if (theme.isDarkMode) {
    const face =
      'linear-gradient(180deg, #333333 0%, #242424 48%, #1a1a1a 100%)';
    return {
      cursor: 'pointer',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      transform: `translateY(${t}px)`,
      transition: 'transform 0.09s ease, box-shadow 0.09s ease, border-color 0.12s ease',
      backgroundImage: face,
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: 'rgba(212, 175, 55, 0.65)',
      boxShadow: pressed
        ? 'inset 0 2px 4px rgba(255,255,255,0.12), inset 0 -2px 4px rgba(0,0,0,0.08), 0 2px 0 #8a6820, 0 5px 14px rgba(138,104,32,0.28)'
        : 'inset 0 3px 6px rgba(255,255,255,0.14), inset 0 -3px 6px rgba(0,0,0,0.06), 0 8px 0 #b8942f, 0 14px 28px rgba(184,148,47,0.38)',
      outline: 'none',
    };
  }
  const face =
    'linear-gradient(180deg, #ffffff 0%, #faf6ef 42%, #ebe4d6 100%)';
  return {
    cursor: 'pointer',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    transform: `translateY(${t}px)`,
    transition: 'transform 0.09s ease, box-shadow 0.09s ease, border-color 0.12s ease',
    backgroundImage: face,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: 'rgba(212, 175, 55, 0.65)',
    boxShadow: pressed
      ? 'inset 0 2px 4px rgba(255,255,255,0.65), inset 0 -2px 4px rgba(0,0,0,0.06), 0 2px 0 #8a6820, 0 5px 14px rgba(138,104,32,0.28)'
      : 'inset 0 3px 6px rgba(255,255,255,0.85), inset 0 -3px 6px rgba(0,0,0,0.05), 0 8px 0 #b8942f, 0 14px 28px rgba(184,148,47,0.38)',
    outline: 'none',
  };
}

export function getTile3dNativeStyle(theme, pressed) {
  const translateY = pressed ? 4 : 0;
  if (theme.isDarkMode) {
    return {
      transform: [{ translateY }],
      backgroundColor: '#242424',
      borderWidth: 2,
      borderColor: 'rgba(212, 175, 55, 0.85)',
      shadowColor: '#8a6820',
      shadowOffset: { width: 0, height: pressed ? 2 : 10 },
      shadowOpacity: pressed ? 0.28 : 0.42,
      shadowRadius: pressed ? 6 : 14,
      elevation: pressed ? 4 : 12,
    };
  }
  return {
    transform: [{ translateY }],
    backgroundColor: '#faf8f4',
    borderWidth: 2,
    borderColor: 'rgba(212, 175, 55, 0.85)',
    shadowColor: '#8a6820',
    shadowOffset: { width: 0, height: pressed ? 2 : 10 },
    shadowOpacity: pressed ? 0.28 : 0.42,
    shadowRadius: pressed ? 6 : 14,
    elevation: pressed ? 4 : 12,
  };
}